<template>
  <div class="loader">
    <div class="loader-header">
      <GFMP :wrapper-styles="{ width: '70%' }" :styles="{ ...fmpStyles.rounded }" />
      <GFMP :wrapper-styles="{ width: '10%' }" :styles="{ ...fmpStyles.rounded }" />
    </div>
    <carousel
      :per-page="isDesktop ? 3 : 1"
      pagination-color="#E5E5E5"
      pagination-active-color="#F384A7"
      class="recent-review-carousel"
    >
      <slide v-for="i in (isDesktop ? 3 : 1) * 4" :key="i">
        <div
          :style="{
            ...(isDesktop && {
              ...((isFirstSlides(i) || isSecondSlides(i)) && {
                paddingRight: '6px',
              }),
              ...((isSecondSlides(i) || isThirdSlides(i)) && {
                paddingLeft: '6px',
              }),
            }),
          }"
        >
          <div class="review-card">
            <div class="review-card-user">
              <div class="review-card-user-profile">
                <GFMP :styles="{ ...fmpStyles.circle, height: '32px', width: '32px' }" />
                <div class="review-card-user-profile-info">
                  <GFMP :styles="{ ...fmpStyles.rounded, width: '52px' }" />
                  <GFMP :styles="{ ...fmpStyles.rounded, width: '96px' }" />
                </div>
              </div>
              <GFMP :styles="{ ...fmpStyles.rounded, height: '10.5px', width: '24px' }" />
            </div>
            <div class="review-card-rating">
              <div class="review-card-rating-star">
                <GFMP v-for="_i in 5" :key="_i" :styles="{ ...fmpStyles.circle, minWidth: '12px' }" />
              </div>
              <GFMP :styles="{ ...fmpStyles.rounded, height: '16px', minWidth: '96px' }" />
            </div>
            <div class="review-card-product">
              <GFMP
                :wrapper-styles="{ height: '100%', aspectRatio: '1/1' }"
                :styles="{ ...fmpStyles.rounded, height: '100%' }"
              />
              <div class="review-card-product-info">
                <GFMP
                  v-for="_i in 3"
                  :key="_i"
                  :styles="{ ...fmpStyles.rounded, height: '8px' }"
                  :wrapper-styles="{ width: `calc(100% / ${_i})` }"
                />
              </div>
              <GFMP
                :wrapper-styles="{ height: '50%', aspectRatio: '1/1' }"
                :styles="{ ...fmpStyles.rounded, height: '100%' }"
              />
            </div>
            <div class="review-card-variant">
              <GFMP :styles="{ ...fmpStyles.circle, minWidth: '12px' }" />
              <GFMP :styles="{ ...fmpStyles.rounded, minWidth: '48px' }" />
            </div>
            <div class="review-card-description">
              <GFMP
                v-for="_i in 6"
                :key="_i"
                :styles="{ ...fmpStyles.rounded, width: `${30 + Math.random() * 70}%` }"
              />
            </div>
            <div class="review-card-photo">
              <GFMP
                v-for="_i in 5"
                :key="_i"
                :wrapper-styles="{ width: '100%', aspectRatio: '1/1' }"
                :styles="{ ...fmpStyles.rounded, height: '100%', width: '100%' }"
              />
            </div>
            <div class="review-card-footer">
              <div class="review-card-footer-start">
                <GFMP v-for="_i in 2" :key="_i" :styles="{ ...fmpStyles.rounded, width: '48px' }" />
              </div>
              <GFMP :styles="{ ...fmpStyles.rounded, height: '24px', width: '24px' }" />
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {
  name: 'expert-review-loader',
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
        },
      },
    };
  },
  computed: {
    isDesktop() {
      return Boolean(this.$store.state.screen.isDesktop);
    },
  },
  methods: {
    isFirstSlides(i) {
      return i % 3 === 1;
    },
    isSecondSlides(i) {
      return i % 3 === 2;
    },
    isThirdSlides(i) {
      return i % 3 === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

.recent-review-carousel {
  &::v-deep {
    .VueCarousel-wrapper {
      padding-bottom: 10px;
    }
    .VueCarousel-pagination {
      bottom: 0;
      .VueCarousel-dot-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        button.VueCarousel-dot {
          padding: 0 !important;
          height: 6px !important;
          width: 6px !important;
          &--active {
            height: 10px !important;
            width: 10px !important;
          }
        }
      }
    }
    .VueCarousel-navigation-prev {
      left: 15px;
    }
    .VueCarousel-navigation-next {
      right: 15px;
    }
  }
  &::v-deep .VueCarousel-inner {
    .VueCarousel-slide {
      position: relative;
      @media (max-width: 768px) {
        left: -5px;
      }
    }
  }
  &::v-deep {
    .VueCarousel-wrapper {
      padding-bottom: 32px;
    }
  }
}
.loader {
  display: flex;
  flex-direction: column;
  gap: 36px;

  &-header {
    display: flex;
    justify-content: space-between;
  }

  .review {
    &-card {
      display: flex;
      flex-direction: column;
      gap: 16px;
      background-color: #f6f6f6;
      height: 480px;
      border-radius: 6px;
      padding: 16px;

      &-user {
        display: flex;
        justify-content: space-between;

        &-profile {
          display: flex;
          gap: 8px;

          &-info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
        }
      }

      &-rating {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-star {
          display: flex;
          gap: 8px;
        }
      }

      &-product {
        display: flex;
        gap: 8px;
        height: 72px;
        padding: 16px;
        border-radius: 8px;
        background-color: #fff;

        &-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex-grow: 1;
        }
      }

      &-variant {
        display: flex;
        gap: 8px;
        padding: 8px;
        border-radius: 8px;
        background-color: #fff;
        width: max-content;
      }

      &-description {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      &-photo {
        display: flex;
        gap: 12px;
      }

      &-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-start {
          display: flex;
          gap: 24px;
        }
      }
    }
  }
}
</style>
